import { render } from "./BtnYandexFood.vue?vue&type=template&id=bb2b2318&scoped=true"
const script = {}

import "./BtnYandexFood.vue?vue&type=style&index=0&id=bb2b2318&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2b2318"]])

export default __exports__